import React from 'react'
import PropTypes from 'prop-types'
import constants from 'lib/constants'
import CellsPerPositionGraph from './CellsPerPositionGraphContainer'
import _ from 'lodash'

class GraphView extends React.Component {
  static propTypes = {
    qcResults: PropTypes.shape({
      low_jobs: PropTypes.arrayOf(PropTypes.shape({
        job_id: PropTypes.number
      })),
      normal_jobs: PropTypes.arrayOf(PropTypes.shape({
        job_id: PropTypes.number
      })),
      high_jobs: PropTypes.arrayOf(PropTypes.shape({
        job_id: PropTypes.number
      }))
    }),
  }

  static defaultProps = {
    qcResults: {
      low_jobs: [],
      normal_jobs: [],
      high_jobs: [],
      flow_times: {}
    }
  }

  render () {
    const { qcResults } = this.props
    return (
      <div style={{ paddingTop: 20 }}>
        {
          _.map(constants.QC_LEVELS, (level) => (
            <div key={level} style={{ marginBottom: 30 }}>
              <h5 style={{ textTransform: 'capitalize', marginBottom: 15 }}>{level} Level</h5>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
                gap: '15px',
                maxWidth: '100%'
              }}>
                {
                  _.map(qcResults[`${level}_jobs`], (job) => {
                    return (
                      <div key={job.job_id} style={{ 
                        border: '1px solid #dee2e6', 
                        borderRadius: '4px', 
                        padding: '10px',
                        textAlign: 'center',
                        backgroundColor: '#fff'
                      }}>
                        <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                          Job: {job.job_id}
                        </div>
                        <CellsPerPositionGraph job={job} />
                      </div>
                    )
                  })
                }
              </div>
            </div>
          ))
        }
      </div>
    )
  }
}

export default GraphView



// WEBPACK FOOTER //
// ./src/routes/QC/components/GraphView.jsx